const StoreSelect = ({ stores, value, onChange }) => (
  <select
    className="form-select form-select-sm w-auto"
    aria-label="Filter by store"
    value={value}
    onChange={(event) => onChange(event.target.value)}
  >
    <option value="">All stores</option>
    {stores.map((store) => (
      <option key={store.id} value={store.id}>
        {store.account_number ? `${store.name} · ${store.account_number}` : store.name}
      </option>
    ))}
  </select>
);

export default StoreSelect;
